// extracted by mini-css-extract-plugin
export default {"chunkBookmark":"ChunkBookmark__chunkBookmark___bNlQo"};